import ProjectViewPage from './ProjectViewPage ';
export default ProjectViewPage;
